var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
// components
import ConfirmEmail from "./components/ConfirmEmail";
import ResetPassword from "./components/ResetPassword";
import { AuthPagesWrapper } from "../LoginPage";
// utils
import { formatErrorMessage } from "module/common/utils";
import { useSubmit } from "module/common/components/forms";
// store
import { postForgotPassword, postResetPassword } from "module/main/store/auth/api";
var WaitEmail = function () { return (_jsxs(_Fragment, { children: [_jsx("h1", { children: "Email Sent" }), _jsx("p", { className: "text-gray mt-2", children: "If the email address provided is associated to an account, you will receive an email with instructions to reset your password." })] })); };
var ForgotPassword = function () {
    var navigate = useNavigate();
    var _a = useState(false), isLoading = _a[0], setIsLoading = _a[1];
    var _b = useState(0), currentStep = _b[0], setCurrentStep = _b[1];
    var _c = useState(null), errorMessage = _c[0], setErrorMessage = _c[1];
    var _d = useState(null), passwordToken = _d[0], setPasswordToken = _d[1];
    var handleForgotSubmit = useSubmit(function (request) {
        setIsLoading(true);
        postForgotPassword(request)
            .then(function () { return setCurrentStep(1); })
            .finally(function () { return setIsLoading(false); });
    });
    var handleResetSubmit = useSubmit(function (request) {
        if (request.password !== request.passwordConfirm)
            return setErrorMessage("Passwords do not match");
        setIsLoading(true);
        postResetPassword(__assign(__assign({}, request), { token: passwordToken || "" }))
            .then(function () { return navigate("/"); })
            .catch(function (error) { return setErrorMessage(formatErrorMessage(error)); })
            .finally(function () { return setIsLoading(false); });
    });
    useEffect(function () {
        var urlParams = new URLSearchParams(window.location.search);
        var token = urlParams.get("token");
        if (token) {
            setPasswordToken(token);
            urlParams.delete("token");
            setCurrentStep(2);
        }
    }, []);
    var renderComponent = function (step) {
        switch (step) {
            case 0:
                return _jsx(ConfirmEmail, { handleForgotSubmit: handleForgotSubmit, isLoading: isLoading });
            case 1:
                return _jsx(WaitEmail, {});
            case 2:
                return _jsx(ResetPassword, { handleResetSubmit: handleResetSubmit, isLoading: isLoading });
            default:
                return _jsx(ConfirmEmail, { handleForgotSubmit: handleForgotSubmit, isLoading: isLoading });
        }
    };
    return (_jsxs(AuthPagesWrapper, { children: [renderComponent(currentStep), errorMessage ? _jsx("div", { className: "bg-danger/50 p-2 mt-2", children: errorMessage }) : null] }));
};
export default ForgotPassword;
